module.exports = __webpack_public_path__ + "static/oira-logo-white-3451f46cc1de0d7b762964982707634e.png";